import { routingErrorPolicy } from './routingErrors';
export const UNCERTAIN_SEND_TEXT = "Delivery not confirmed yet. Don't send again, we're checking.";
export function reportOutcomeSummary(stages = []) {
  const accepted = stages.filter(stage => stage.success).length;
  return stages.some(stage => stage.messaging_operation)
    ? `${accepted} of ${stages.length} provider acceptances. Delivery is tracked in chat.`
    : `${accepted} of ${stages.length} deliveries`;
}
export function businessSendOutcome(value) {
  const payload = value?.response?.data;
  const data = payload?.data || {};
  const code = payload?.error?.code || data.code || payload?.code || value?.code || value?.reason || '';
  if (code === 'MESSAGING_ROUTING_TAKEOVER_FAILED') return { delivery:'rejected', code, operation_id:null, message:routingErrorPolicy(code).message, reason:code };
  const rejected = value?.delivery === 'rejected' || code === 'MESSAGING_PROVIDER_REJECTED';
  const uncertain = !rejected && (value?.delivery === 'uncertain' || value?.reconciliation_required === true
    || data.reconciliation_required === true || /RECONCILIATION|UNCERTAIN|TEMPORARY|TIMEOUT|SEND_FAILED/.test(code)
    || (value instanceof Error && !value.response && (!value.code || ['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT'].includes(value.code)))
    || Number(value?.response?.status || value?.status) >= 500);
  if (!rejected && !uncertain) return null;
  const reason = value?.reason || payload?.error?.message || payload?.message || value?.message || code;
  return { delivery: rejected ? 'rejected' : 'uncertain', code,
    operation_id: payload?.error?.details?.operation_id || value?.details?.operation_id || value?.operation_id || null,
    message: uncertain ? UNCERTAIN_SEND_TEXT : `WATI rejected the send: ${reason || 'Provider refused the message.'}`,
    reason: typeof reason === 'string' ? reason : code };
}
